import styled from 'styled-components'
import IconBase from '@/components/icon'

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  width: 10px;
  height: 10px;
  svg {
    margin-top: 1px;
    transition: transform 0.3s ease-in-out 0s;
    transform: rotate(0deg);
  }
  &[data-open='true'] {
    svg {
      transform: rotate(180deg);
    }
  }
`

type IconProps = {
  open: boolean
}

export const ExpandIcon: React.FC<IconProps> = ({ open }) => {
  return (
    <Wrapper data-open={open}>
      <IconBase id="chevron" width={10} height={6} />
    </Wrapper>
  )
}
